import { a as _, u as v } from "./chunk-useConsent-BP9louur.js";
const E = (e, i, a) => {
  const o = i / 100 / 360 * 30, s = e * o / (1 - Math.pow(1 + o, -a));
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    roundingMode: "ceil",
    maximumFractionDigits: 0,
    // @ts-ignore
    trailingZeroDisplay: "stripIfInteger"
  }).format(s);
}, u = !1;
_(
  () => g(),
  () => L(),
  ["marketing", "analytics"],
  u
);
const L = () => {
  window._affirm_config = void 0, window.affirm = void 0, document.querySelectorAll("affirm-messaging").forEach((e) => {
    e.reRender();
  });
}, g = (e) => {
  window._affirm_config = {
    public_api_key: "XX6Q80P2LXHURUIN",
    script: "https://cdn1.affirm.com/js/v2/affirm.js"
  }, function(i, a, o, s, t, c, r) {
    var m, n = i[o] || {}, d = document.createElement(c), l = document.getElementsByTagName(c)[0], f = function(p, y, w) {
      return function() {
        p[y]._.push([w, arguments]);
      };
    };
    for (n[s] = f(n, s, "set"), m = n[s], n[t] = {}, n[t]._ = [], m._ = [], n[t][r] = f(n, t, r), t = 0, r = "set add save post open empty reset on off trigger ready setProduct".split(
      " "
    ); t < r.length; t++)
      m[r[t]] = f(n, s, r[t]);
    for (t = 0, r = ["get", "token", "url", "items"]; t < r.length; t++)
      m[r[t]] = function() {
      };
    d.async = !0, d.src = a[c], l.parentNode.insertBefore(d, l), delete a[c], m(a), i[o] = n;
  }(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready"), affirm.ui.ready(function() {
    e && affirm.ui.openModal(e);
  });
};
class T extends HTMLElement {
  constructor() {
    super(), this.pageType = this.getAttribute("data-page-type"), this.amount = Number(this.getAttribute("data-amount")), this.dollars = this.getAttribute("data-dollars"), this.months = Number(this.getAttribute("data-months")), this.rate = 15;
  }
  connectedCallback() {
    this.initialState = this.innerHTML, this.render();
  }
  render() {
    this.monthlyPayment = this.querySelector("[data-monthly-payment]"), this.monthlyPayment.innerText = E(
      this.dollars,
      this.rate,
      this.months
    ), this.setUpListeners();
  }
  reRender() {
    this.innerHTML = this.initialState, this.render();
  }
  setUpListeners() {
    this.modalTrigger = this.querySelector("[data-affirm-modal-trigger]"), this.modalTrigger.addEventListener("click", (i) => {
      i.preventDefault(), v(
        () => g({
          page_type: this.pageType,
          amount: this.amount
        }),
        null,
        ["marketing", "analytics"],
        !0,
        u
      ), h();
    });
  }
}
window.customElements.get("affirm-messaging") || window.customElements.define("affirm-messaging", T);
const h = () => {
  document.querySelector("app-provider").dispatchEvent(
    new CustomEvent("modal-dialog::close", {
      bubbles: !0,
      composed: !0,
      detail: "cart-drawer-dialog"
    })
  );
};
document.addEventListener("click", (e) => {
  e.target.classList.contains("affirm-modal-trigger") && h();
});
